import { Component, OnInit, effect, signal } from '@angular/core'
import { OcBadgeComponent } from 'otimus-library'
import { InternationalizationService } from 'src/app/services/internationalization.service'
import { MessageChatComponent } from '../../modules/message-chat/components/message-chat/message-chat.component'
import { MessageChatSessionService } from '../../modules/message-chat/services/message-chat-session.service'
import { MessageChatStateService } from '../../modules/message-chat/services/message-chat-state.service'
import { AuthenticatedUserComponent } from './authenticated-user/authenticated-user.component'
import { SearchComponent } from './search/search.component'

@Component({
  selector: 'app-topbar',
  imports: [SearchComponent, AuthenticatedUserComponent, MessageChatComponent, OcBadgeComponent],
  templateUrl: './topbar.component.html',
  styleUrl: './topbar.component.scss',
})
export class TopbarComponent implements OnInit {
  protected readonly chatOpen = signal(false)

  constructor(
    private readonly session: MessageChatSessionService,
    protected readonly chatState: MessageChatStateService,
    protected readonly translateService: InternationalizationService,
  ) {
    effect(() => {
      if (this.chatState.pendingOpenUser() !== null) {
        this.chatOpen.set(true)
      }
    })
  }

  ngOnInit(): void {
    this.session.initialize()
  }

  protected openChat(): void {
    this.chatOpen.set(true)
  }

  protected closeChat(): void {
    this.chatOpen.set(false)
  }
}
